import React from 'react';
import { useCodaWidget } from '../hooks/useCodaWidget';
import { CodaWidgetPosition } from '../types';

export interface CodaWidgetProps {
  position?: CodaWidgetPosition;
  expanded?: boolean;
  enabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: string | boolean | React.CSSProperties | undefined;
}

export function CodaWidget({
  position = 'bottom-right',
  expanded = false,
  className = '',
  style = {},
  children,
  ...rest
}: CodaWidgetProps): JSX.Element | null {
  const reactSpecificProps = ['children', 'key', 'ref'];
  const { containerRef, isConfigured } = useCodaWidget({
    position,
    expanded,
    ...Object.entries(rest)
      .filter(([key]) => !reactSpecificProps.includes(key))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {}),
  });

  if (!isConfigured) {
    return null;
  }

  return <div ref={containerRef} className={`coda-widget-container ${className}`} style={style} />;
}
